'use client';

import Script from 'next/script';

export type GTagSSParams = {
  tagId?: string;
  serverContainerUrl?: string;
  dataLayerName?: string;
};

declare global {
  interface Window {
    dataLayer?: Object[];
    gtag: (type: string, event: string, params: any) => void;
  }
}

let currDataLayerName: string | undefined = undefined;
let currServerContainerUrl: string | undefined = undefined;

export function GoogleTagServerSide(props: GTagSSParams) {
  const { tagId, serverContainerUrl, dataLayerName = 'dataLayer' } = props;

  if (currDataLayerName === undefined) {
    currDataLayerName = dataLayerName;
  }

  if (currServerContainerUrl === undefined) {
    currServerContainerUrl = serverContainerUrl;
  }

  return (
    <>
      <Script
        id="_next-ga-init"
        dangerouslySetInnerHTML={{
          __html: `
        window['${dataLayerName}'] = window['${dataLayerName}'] || [];
        function gtag(){window['${dataLayerName}'].push(arguments);}
        gtag('js', new Date());

        gtag('config', '${tagId}', {
         'server_container_url': '${serverContainerUrl}',
         'debug_mode':true,
        });`,
        }}
      />
      <Script id="_next-ga" src={`${serverContainerUrl}/gtag/js?id=${tagId}`} />
    </>
  );
}

export function sendEvent(event: string, params: {} | undefined) {
  if (currDataLayerName === undefined) {
    console.warn(`GoogleTagServerSide has not been initialized`);
    return;
  }

  if (currServerContainerUrl === undefined) {
    console.warn(
      `GoogleTagServerSide has not been configured with a server container URL`,
    );
    return;
  }

  if (typeof window.gtag !== 'undefined') {
    //window[currDataLayerName].push( { event: event, ...params} )
    window.gtag('event', event, params);
  } else {
    console.warn(`GoogleTagServerSide ${currDataLayerName} does not exist`);
  }
}
